import { render, staticRenderFns } from "./ManageMovement.vue?vue&type=template&id=9594f7b6&scoped=true&"
import script from "./ManageMovement.vue?vue&type=script&lang=js&"
export * from "./ManageMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9594f7b6",
  null
  
)

export default component.exports